import React from 'react';
import {TextField, Toolbar} from "@material-ui/core";
import InputAdornment from "@material-ui/core/InputAdornment";
import IconButton from "@material-ui/core/IconButton";
import Search from '@material-ui/icons/Search';
import FilterListIcon from '@material-ui/icons/FilterList';
import ListHoc from "../../../../../HocHelpers/ListHoc";
import ImportExportIcon from '@material-ui/icons/SaveAlt';
import {useSelector} from "react-redux";
import {multiLanguageValue} from "../../../../JsonScreen/Utils/lib";


const TableToolbarList = (props) => {
    const {
        label, isCompact, hideListHeader,
        hideQuickSearch, hideAdvancedSearch, hideLabel,
        listName, exportable
    } = props;
    const {userLanguage} = useSelector(state => state.app);
    const multiLanguageLabel = multiLanguageValue(label, userLanguage)
    return (
        <>
            {!hideListHeader && (
                <Toolbar id={`listToolBar_${listName}`}
                         style={{
                             minHeight: isCompact && 26,
                             padding: '0 0 5px 10px',
                             background: 'rgba(0, 0, 0, .03)'
                         }}>
                    <div style={{flexGrow: 1, alignSelf: 'flex-end'}}>
                            <span style={{fontSize: '1.2em', fontWeight: 500}} id="tableTitle">
                                {hideLabel ? '' : multiLanguageLabel}
                            </span>
                    </div>
                    {!hideQuickSearch &&
                        <TextField
                            disabled
                            placeholder="Search..."
                            autoComplete="off"
                            InputProps={{
                                style: {width: 115},
                                startAdornment: (
                                    <InputAdornment position="start">
                                        <IconButton
                                            disabled
                                            style={{padding: 0}}
                                            aria-label="search menu items"
                                        >
                                            <Search/>
                                        </IconButton>
                                    </InputAdornment>),
                            }}
                        />}
                    {!hideAdvancedSearch &&
                        <IconButton disabled style={{margin: '0 10px', padding: 0}}
                                    aria-label="filter list">
                            <FilterListIcon/>
                        </IconButton>}

                    {exportable &&
                        <IconButton disabled
                                    aria-label="filter list"
                                    style={{margin: '0 10px', padding: 0}}>
                            <ImportExportIcon/>
                        </IconButton>}

                </Toolbar>
            )}
        </>
    )
}

export default ListHoc(TableToolbarList);